"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const image_component_1 = require("@kyruus/image-component");
const ProviderInfo = ({ providerImg, providerName, providerSpecialties }) => {
    const { config } = (0, image_component_1.useImageService)();
    return (react_1.default.createElement(styles_1.Row, { "data-testid": "ProviderInfo" },
        react_1.default.createElement(styles_1.ProviderImgContainer, null,
            react_1.default.createElement(styles_1.ProviderImg, { src: providerImg, altText: providerName, width: 56, height: 56, enhancementEnabled: config.enableEnhancement, "data-testid": "ProviderImage" })),
        react_1.default.createElement(styles_1.ProviderTitleSpecialtiesContainer, null,
            react_1.default.createElement(styles_1.ProviderTitle, { id: "provider-name", "data-testid": "ProviderTitle" }, providerName),
            react_1.default.createElement(styles_1.ProviderSpecialities, { "data-testid": "ProviderSpecialties" }, providerSpecialties))));
};
exports.default = ProviderInfo;
//# sourceMappingURL=ProviderInfo.js.map